export default __webpack_public_path__ + "static/media/04n.3bbb8b11.svg";